import accountManager from 'ai-assistant-lib/src/utils/account';

// accountManager.changeKeys({
//   LoginType: 'PortalLoginType',
// });

export default accountManager;
